import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { CommonService } from 'src/@services/common.service';
import { FormService } from 'src/@services/form.service';
import { CommonPagesService } from '../../common-pages.service';
import { ResponseStatus, ValidationMessage } from '../../enum';

@Component({
  selector: 'app-add-update-under-review',
  templateUrl: './add-update-under-review.component.html',
  styleUrls: ['./add-update-under-review.component.scss'],

  standalone: false,
})
export class AddUpdateUnderReviewComponent {
  isVisibleUnderReviewDrawer = true;
  underReviewDrawerTitle = 'Add Under Review';
  isLoadingUpload = false;
  isLoadingOne = false;
  darkColorStyle: any;
  lightColorValidationColor: any;
  darkColorValidationColor: any;
  lightColorStyle: any;
  uploadResult: any = null;
  uploadFlag: any = false;
  @Output() hideUnderReviewDrawer = new EventEmitter();
  @Input() selectedUnderReviewData: any;
  @Input() transactionType: any;
  url: any;
  validationMessage = ValidationMessage;
  deleteIcon: any;
  userDetails: any;
  files: any[] | undefined;
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '15rem',
    maxHeight: '25rem',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter email copy content here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' },
    ],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText',
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
    uploadUrl: 'https://api.exapple.com/v1/image/upload',
    uploadWithCredentials: false,
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['insertImage', 'insertVideo', 'insertUnorderedList'],
    ],
    upload: this.uploadImageByAngularEditor,
  };
  currentUploadedImageSize: any;

  constructor(
    public _cs: CommonService,
    private _cpS: CommonPagesService,
    public _fS: FormService
  ) {
    _fS.underReviewForm_fb();
  }

  ngOnInit(): void {
    if (this.selectedUnderReviewData != null) {
      this.underReviewDrawerTitle =
        'Edit Under Review (' + this.selectedUnderReviewData.reason + ')';
      this._fS.underReviewForm.patchValue({
        reason: this.selectedUnderReviewData.reason,
        color: this.selectedUnderReviewData.color,
        emailCopy: this.selectedUnderReviewData.emailCopy,
      });
      this.lightColorStyle = this._fS.underReviewForm.value.color;
    }
  }
  uploadImageByAngularEditor(file: File): any {
    var url, img: any;
    let reader = new FileReader();
    img = new Image();
    img.onload = () => {
      var size = img.height + ' X ' + img.width;
      try {
        var ButtonElement = document.getElementById(
          'UpdateUploadedImageSizeButton'
        );
        ButtonElement?.setAttribute('currentUploadedImageSize', size);
        ButtonElement?.click();
      } catch (ex) {}
    };
    img.src = URL.createObjectURL(file);
    reader.onload = () => {
      url = reader.result;
      document.execCommand('insertHTML', false, `<img src='${url}'>`);
    };
    reader.abort();
    if (file) {
      reader.readAsDataURL(file);
    }
  }

  onFileChange(pFileList: any) {
    this.files = Object.keys(pFileList).map((key: any) => pFileList[key]);
    this.files.forEach((file: any) => {
      this.uploadImageByAngularEditor(file);
    });
  }
  applyColorlightColor() {
    this.lightColorStyle = this._fS.underReviewForm.value.color;
  }

  //cancel update Agency
  handleCancel(data?: any) {
    this.isVisibleUnderReviewDrawer = false;
    this.hideUnderReviewDrawer.emit({
      hide: this.isVisibleUnderReviewDrawer,
      data: data ? data : null,
    });
  }

  //add/update Agency
  handleOk() {
    if (this._fS.underReviewForm.valid) {
      const formValue = this._fS.underReviewForm.value;
      var underReviewBody = {
        reason: formValue.reason,
        color: formValue.color,
        emailCopy: formValue.emailCopy,
        orderNo: this.selectedUnderReviewData
          ? this.selectedUnderReviewData.orderNo
          : 1,
        transactionType: this.transactionType,
      };
      if (this.selectedUnderReviewData) {
        underReviewBody['id'] = this.selectedUnderReviewData.id;
        this.UpdateUnderReview(underReviewBody);
      } else {
        this.addUnderReview(underReviewBody);
      }
    } else {
      //to fire validations on invalid fields
      Object.values(this._fS.underReviewForm.controls).forEach(
        (control: any) => {
          if (control.invalid) {
            control.markAsDirty();
            this.lightColorValidationColor =
              this._fS.underReviewForm.controls.color.status;
            control.updateValueAndValidity({ onlySelf: true });
          }
        }
      );
    }
  }

  //api call to add/update agency
  addUnderReview(underReviewBody: any) {
    this.isLoadingOne = true;
    // underReviewBody = JSON.stringify(underReviewBody)
    this._cpS.createUnderReview(underReviewBody).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this._cs.displayMessage('success', response.message);

        this.handleCancel(response.result);
        this.isLoadingOne = false;
      } else {
        this._cs.displayMessage('error', response.message);
        this.isLoadingOne = false;
      }
    });
  }
  UpdateUnderReview(underReviewBody: any) {
    this.isLoadingOne = true;
    this._cpS.updateUnderReview(underReviewBody).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this._cs.displayMessage('success', response.message);

        this.handleCancel(response.result);
        this.isLoadingOne = false;
      } else {
        this._cs.displayMessage('error', response.message);
        this.isLoadingOne = false;
      }
    });
  }
}
